var _clipPath, _clipPath2, _path, _path2, _use, _use2, _use3, _use4, _use5, _path3, _g, _path4, _g2, _path5, _path6, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v75h350v75h-50zm300 0h-150v200h-150v-50z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h300v150h-300z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h600v300h-600z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "m600 260.88c-6.723 4.045-12.499 13.498-30.36 13.498-35.711 0-44.641-19.902-71.427-19.902-17.856 0-26.785 19.902-44.641 19.902-35.715 0-44.643-19.902-71.429-19.902-17.857 0-26.786 19.902-44.643 19.902-35.714 0-44.643-19.902-71.428-19.902-17.858 0-26.786 19.902-44.643 19.902-35.714 0-44.643-19.902-71.429-19.902-17.858 0-26.786 19.902-44.643 19.902-35.714 0-44.643-19.902-71.428-19.902-17.858 0-23.215 14.182-33.929 14.182v25.621c10.714 0 16.071-14.181 33.929-14.181 26.785 0 35.714 19.901 71.428 19.901 17.857 0 26.785-19.901 44.643-19.901 26.785 0 35.715 19.901 71.429 19.901 17.857 0 26.785-19.901 44.643-19.901 26.785 0 35.714 19.901 71.428 19.901 17.857 0 26.786-19.901 44.643-19.901 26.786 0 35.714 19.901 71.429 19.901 17.856 0 26.785-19.901 44.641-19.901 26.786 0 35.716 19.901 71.427 19.901 17.861 0 23.637-5.64 30.36-9.684z",
    fill: "#012169"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    transform: "translate(0 -49.753)",
    xlinkHref: "#c"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(0 -99.507)",
    xlinkHref: "#c"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(0 -149.26)",
    xlinkHref: "#c"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(0 -199.01)",
    xlinkHref: "#c"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(0 -248.77)",
    xlinkHref: "#c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h290v152h-290z",
    fill: "#fff",
    strokeWidth: 0.98319
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h300v150h-300z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 300 150m0-150-300 150",
    stroke: "#fff",
    strokeWidth: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 300 150m0-150-300 150",
    clipPath: "url(#a)",
    stroke: "#c8102e",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150 0v200m-150-125h350",
    stroke: "#fff",
    strokeWidth: 50
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150 0v200m-150-125h350",
    stroke: "#c8102e",
    strokeWidth: 30
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m446.52 79.222-2.0691 204.16c-.27981 11.585 10.345 11.631 10.345 0l-2.0691-204.16z",
    fill: "#a24300",
    stroke: "#000",
    strokeWidth: 0.75
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.43857 0 0 .37683 122.2 25.058)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.31451 .10485 -.13829 -.30324 1046.5 373.32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d",
    fill: "none",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(177.17 -224.05)",
    d: "m496.06 549.21 17.717 70.866 35.433-53.15-17.717 88.583 35.433-35.433-35.433 88.582 35.433-35.433-35.433 88.583 35.433-35.433-35.433 106.3 35.433-35.433-35.433 106.3 35.433-35.433-35.433 106.3-17.716 53.151-17.717 17.72-17.717-17.72-17.716-53.151-35.433-106.3 35.433 35.433-35.433-106.3 35.433 35.433-35.433-106.3 35.433 35.433-35.433-88.583 35.433 35.433-35.433-88.582 35.433 35.433-17.717-88.583 35.433 53.15z",
    fill: "#006d00",
    stroke: "#000",
    strokeWidth: 4.4527
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(177.17 -224.05)",
    d: "m496.06 549.21v496.07"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(177.17 -224.05)",
    d: "m425.2 868.11 70.866 106.3 70.866-106.3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(177.17 -224.05)",
    d: "m425.2 797.24 70.866 106.3 70.866-106.3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(177.17 -224.05)",
    d: "m425.2 726.38 70.866 106.3 70.866-106.3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(177.17 -224.05)",
    d: "m425.2 673.23 70.866 88.583 70.866-88.583"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(177.17 -224.05)",
    d: "m425.2 620.08 70.866 88.582 70.866-88.582"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(177.17 -224.05)",
    d: "m442.91 566.93 53.15 106.3 53.15-106.3"
  }))), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(.23652 -.28186 .29496 .22762 354.57 204.65)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(.15164 .33524 -.3329 .16731 907.54 -153.47)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(-.20952 .30246 -.3147 -.19945 1141.4 167.58)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(-.20772 -.25838 .23618 -.23515 689.99 567.28)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.36218 -.099472 -.20981 .31773 1222.4 -24.229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e",
    fill: "none",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(283.46 -124.02)",
    d: "m460.63 549.21 28.643 70.866 42.223-53.15-10.184 88.583 27.9-35.433-17.716 88.582 25.249-35.433-25.249 88.583 35.433-35.433-35.433 106.3 35.433-35.433-35.433 106.3 35.433-35.433-35.433 106.3-17.716 53.151-17.717 17.72-17.717-17.72-17.716-53.151-35.433-106.3 35.433 35.433-35.433-106.3 35.433 35.433-35.433-106.3 35.433 35.433-45.617-88.583 45.617 35.433-53.15-88.582 42.966 35.433-25.25-88.583 35.433 53.15z",
    fill: "#006d00",
    stroke: "#000",
    strokeWidth: 3.3357
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(283.46 -124.02)",
    d: "m467.21 584.65 28.855 124.02v336.62"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(283.46 -124.02)",
    d: "m436.23 885.83 59.833 88.582 60.682-88.582"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(283.46 -124.02)",
    d: "m434.53 814.96 61.53 88.582 60.682-88.582"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(283.46 -124.02)",
    d: "m435.38 744.1 60.682 88.582 59.833-88.582"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(283.46 -124.02)",
    d: "m432.84 690.94 63.228 70.866 53.149-70.866"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(283.46 -124.02)",
    d: "m425.2 637.8 70.866 70.865 45.406-70.865"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(283.46 -124.02)",
    d: "m436.12 593.24 53.15 86.886 35.327-95.478"
  }))), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(.36088 .10411 .013211 .38052 452.76 -239.27)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.046132 -.36474 .32602 .064796 386 315.21)",
    fill: "none",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m354.33 531.5 88.583 88.583 17.716-53.149v88.582l35.433-35.433-17.716 88.583 35.432-35.434-17.716 88.584 35.433-35.433-17.716 106.3 35.433-35.433-35.433 106.3 35.433-35.433-17.717 106.3-17.716 53.151-17.717 17.72-17.717-17.72-17.716-53.151-53.15-82.294 35.434 11.429-35.433-106.3 35.433 35.433-53.15-106.3 35.433 35.433-53.15-88.584 53.15 35.434-70.866-88.583 53.149 35.433-70.866-70.866 70.866 35.433z",
    fill: "#006d00",
    stroke: "#000",
    strokeWidth: 3.5227
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.96 560.02 63.952 95.497 17.716 53.15 8.859 45.205 8.858 78.811 9.315 70.866 8.401 141.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.2 903.54 63.665 70.866 50.749-88.583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m417.08 814.96 70.579 88.583 50.75-88.583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m407.48 752.44 70.867 80.235 45.948-88.583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m372.05 637.8 88.583 70.866 25.831-70.866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.62 602.36 82.296 53.149 10.515-53.149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m389.76 690.94 81.095 70.866 33.946-70.866"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m451.75 194.52h28.445s1.8718-4.2495 2.0825-6.1319c.25312-2.2613.24523-2.9867-.2771-5.0698-.5411-2.1579-1.3267-3.6407-2.6787-5.0826-1.2751-1.3599-3.0713-2.2023-4.9109-2.6615-1.6408-.40957-3.4948-.5849-4.934-.26532-2.7338.60704-4.5099 1.5684-7.4818 2.5786-2.1438.72869-3.7824.97852-5.9501 1.111-1.3259.0811-2.8586-.27523-4.2952-.60528z",
    color: "#000000",
    fill: "#fff",
    opacity: 0.995
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m447.51 194.52h-28.446s-1.8714-4.2495-2.0821-6.1319c-.25312-2.2613-.24523-2.9867.2771-5.0698.54109-2.1579 1.3267-3.6407 2.6787-5.0826 1.2751-1.3599 3.0713-2.2023 4.9109-2.6615 1.6408-.40957 3.4948-.5849 4.934-.26532 2.7338.60704 4.5099 1.5684 7.4818 2.5786 2.1438.72869 3.7824.97852 5.9501 1.111 1.3259.0811 2.8583-.27523 4.295-.60528z",
    color: "#000000",
    fill: "#fff",
    opacity: 0.995
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.44777 0 0 .48232 46.628 -169.53)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-187.47 -.37816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1078.8 808.64c-9.0021.10633-18.004.28353-26.935.85059-6.5921.49618-14.106 1.0632-20.52 1.9847l-1.6303.28354c-4.0403.77971-4.6074 5.5997-2.4809 8.2224 4.3238 5.4225 29.948 9.64 60.215 9.64 30.231 0 55.856-4.2175 60.179-9.64 2.1265-2.6227 1.5594-7.4427-2.4809-8.2224l-1.6303-.28354c-6.3794-.92147-13.928-1.4885-20.52-1.9847-8.9312-.56706-17.933-.74426-26.935-.85059h-8.6122z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m1093.5 813.82c-2.2328-.35442-4.2884-.81515-6.2376-1.3113-1.7012-.46073-3.2961-.95691-4.8555-1.4885.4608.74427 1.1341 1.4885 2.7644 2.0556-1.3113-.0354-3.0479.46073-3.6859.74427.638.24809 2.4455.74426 3.7568.70882-1.5948.56706-2.1973 1.3113-2.5518 2.0556 1.3823-.49618 2.8708-.95692 4.4302-1.3822 1.9847-.53162 4.0758-.99236 6.3794-1.3822z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1069.9 813.92c-2.2328-.28352-4.2884-.67337-6.2377-1.1341-1.7366-.38986-3.3669-.8506-4.8909-1.3468.4253.74426 1.1342 1.4531 2.7999 1.9847-1.3468 0-3.0479.56706-3.6504.8506.6379.24808 2.4454.67337 3.7567.6025-1.5594.6025-2.1619 1.3822-2.5163 2.1265 1.3822-.53161 2.8353-1.0632 4.3947-1.524 1.9847-.6025 4.0758-1.0987 6.344-1.5594z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1046.6 815.06c-2.2328-.14177-4.3593-.38985-6.344-.70883-1.7366-.28352-3.4024-.6025-4.9618-.99235.4962.70883 1.2405 1.3822 2.9416 1.7721-1.3113.10633-2.977.77971-3.5795 1.0987.6734.17721 2.4809.49618 3.7922.35442-1.524.70883-2.0556 1.524-2.3391 2.3037 1.3467-.63794 2.7644-1.2759 4.2884-1.8429 1.9138-.74427 3.9694-1.4177 6.2022-1.9847z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1117 814.28c-2.2328.31896-4.3239.67337-6.2731 1.1341-1.7367.38986-3.367.8506-4.8909 1.3822.4607-.74426 1.1341-1.4885 2.7998-1.9847-1.3113-.0354-3.0479-.56706-3.6504-.85059.6379-.24809 2.4454-.67339 3.7568-.63795-1.5595-.6025-2.162-1.3468-2.4809-2.1265 1.3822.56706 2.8353 1.0632 4.3947 1.5594 1.9493.56706 4.0403 1.0987 6.344 1.524z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1140.3 816.23c-2.2328.14177-4.3238.35442-6.3085.67339-1.7367.28353-3.4024.63794-4.9973 1.0278.5317-.70882 1.2759-1.3822 2.9771-1.7721-1.3468-.10632-3.0125-.77971-3.615-1.0987.6734-.21265 2.4809-.53162 3.8277-.35442-1.524-.70882-2.0911-1.524-2.3746-2.3037 1.3468.63795 2.7644 1.2404 4.2884 1.843 1.9138.70882 3.9694 1.3822 6.2022 1.9847z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1087.5 818.92c-36.079 0-57.947 2.091-56.139 3.6859 12.653 5.2808 37.568 6.9819 56.139 7.0174 18.536-.0354 43.451-1.7366 56.104-7.0174 1.8075-1.5949-20.06-3.6859-56.104-3.6859z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1143.5 822.71c.319-.8506-1.0987-1.0987-2.5872-1.2759-5.777-.74427-12.192-1.2404-17.898-1.6658-8.9312-.56706-17.933-.74426-26.935-.85058h-17.26c-9.0021.10632-18.004.28352-26.935.85058-5.7061.4253-12.121.92148-17.898 1.6658-1.4885.1772-2.9062.42529-2.5872 1.2759",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.616
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1078.8 808.64c-9.0021.10633-18.004.28353-26.935.85059-6.5921.49618-14.106 1.0632-20.52 1.9847l-1.6303.28354c-4.0403.77971-4.6074 5.5997-2.4809 8.2224 4.3238 5.4225 29.948 9.64 60.215 9.64 30.231 0 55.856-4.2175 60.179-9.64 2.1265-2.6227 1.5594-7.4427-2.4809-8.2224l-1.6303-.28354c-6.3794-.92147-13.928-1.4885-20.52-1.9847-8.9312-.56706-17.933-.74426-26.935-.85059h-8.6122z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.616
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5239 0 0 .5239 734.5 554.88)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.47385 0 0 .5 -169.17 117.35)",
    strokeWidth: 2.417
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1219.6 702.3 17.558-48.601 7.0916-20.121 17.575-10.352 17.8-38.344 8.3852-10.028 1.2943-35.329s-12.298-25.061-31.33-34.06c-27.225-12.874-64.179-11.103-64.179-11.103s-8.5364-21.396-24.193-29.722c-15.657-8.3261-33.042-10.333-51.289-10.333s-50.995 15.463-68.704 20.008c-9.2065 2.363-29.998 10.333-29.998 10.333s-20.792-7.9701-29.998-10.333c-17.709-4.5453-50.457-20.008-68.704-20.008-18.247 0-35.064 1.7049-51.289 10.333-15.089 8.0241-35.803 29.722-35.803 29.722s-23.717-3.051-40.379 6.4502c-20.783 11.851-35.428 36.778-35.428 36.778l1.4349 38.601 3.2727 14.755 13.43 14.63 17.507 29.548 12.543 29.142 13.425 38.035z",
    fill: "#c8102e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1219.6 702.3 17.558-48.601 7.0916-20.121 17.575-10.352 17.8-38.344 8.3852-10.028 1.2943-35.329s-12.298-25.061-31.33-34.06c-27.225-12.874-64.179-11.103-64.179-11.103s-8.5364-21.396-24.193-29.722c-15.657-8.3261-33.042-10.333-51.289-10.333s-50.995 15.463-68.704 20.008c-9.2065 2.363-29.998 10.333-29.998 10.333s-20.792-7.9701-29.998-10.333c-17.709-4.5453-50.457-20.008-68.704-20.008-18.247 0-35.064 1.7049-51.289 10.333-15.089 8.0241-35.803 29.722-35.803 29.722s-23.717-3.051-40.379 6.4502c-20.783 11.851-35.428 36.778-35.428 36.778l1.4349 38.601 3.2727 14.755 13.43 14.63 17.507 29.548 12.543 29.142 13.425 38.035z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.417
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.1765
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-139.77 75.518)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.2835 10.459)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 923.9 0)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.1765
  }, /*#__PURE__*/React.createElement("path", {
    d: "m358.41 213.62c-9.0186 2.0007-18.587 5.9746-26.125 13.438-6.9868 6.9175-11.634 15.083-14.312 25-2.507 9.2816-2.5832 14.802-1.4688 24.045 1.434 11.893 8.75 23.83 8.75 23.83l12.611-2.25s-7.5991-16.016-8.4545-23.111c-1.0276-8.5228-.99559-11.257 1.125-19.108 2.1967-8.1331 5.3862-13.722 10.875-19.156 5.1768-5.1254 12.469-8.3005 19.938-10.031 6.6614-1.5437 14.188-2.2045 20.031-1 11.099 2.2879 18.309 5.9114 30.375 9.7188 8.7034 2.7464 15.356 3.688 24.156 4.1875 5.3829.30553 11.605-1.0373 17.438-2.2812s10.719-2.5312 10.719-2.5312l-3.2812-12.594s-4.6615 1.2344-10.156 2.4062-12.358 2.1227-13.969 2.0312c-8.297-.47093-13.168-1.1633-20.969-3.625-11.169-3.5243-19.074-7.4316-31.688-10.062-8.4994-1.7728-17.217-.76456-25.594 1.0938z",
    color: "#000000",
    fill: "#fed100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m358.41 213.62c-9.0186 2.0007-18.587 5.9746-26.125 13.438-6.9868 6.9175-11.634 15.083-14.312 25-2.507 9.2816-2.5832 14.802-1.4688 24.045 1.434 11.893 8.75 23.83 8.75 23.83l12.611-2.25s-7.5991-16.016-8.4545-23.111c-1.0276-8.5228-.99559-11.257 1.125-19.108 2.1967-8.1331 5.3862-13.722 10.875-19.156 5.1768-5.1254 12.469-8.3005 19.938-10.031 6.6614-1.5437 14.188-2.2045 20.031-1 11.099 2.2879 18.309 5.9114 30.375 9.7188 8.7034 2.7464 15.356 3.688 24.156 4.1875 5.3829.30553 11.605-1.0373 17.438-2.2812s10.719-2.5312 10.719-2.5312l-3.2812-12.594s-4.6615 1.2344-10.156 2.4062-12.358 2.1227-13.969 2.0312c-8.297-.47093-13.168-1.1633-20.969-3.625-11.169-3.5243-19.074-7.4316-31.688-10.062-8.4994-1.7728-17.217-.76456-25.594 1.0938z",
    color: "#000000",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.1765
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.88389
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.331 0 0 1.331 679.36 -1151.1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5 0 0 .5 -1617.5 688.21)",
    strokeWidth: 1.7678
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.7678
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.331 0 0 1.331 676 -1167.8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5 0 0 .5 -1617.5 688.21)",
    strokeWidth: 1.7678
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.7678
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.331 0 0 1.331 677.01 -1185.6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5 0 0 .5 -1617.5 688.21)",
    strokeWidth: 1.7678
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.7678
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.331 0 0 1.331 683.83 -1202.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5 0 0 .5 -1617.5 688.21)",
    strokeWidth: 1.7678
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.7678
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.331 0 0 1.331 696.57 -1215.6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5 0 0 .5 -1617.5 688.21)",
    strokeWidth: 1.7678
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.7678
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.331 0 0 1.331 712.48 -1224.2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5 0 0 .5 -1617.5 688.21)",
    strokeWidth: 1.7678
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.7678
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.331 0 0 1.331 730.67 -1228.8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5 0 0 .5 -1617.5 688.21)",
    strokeWidth: 1.7678
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.7678
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.331 0 0 1.331 749.32 -1227.9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5 0 0 .5 -1617.5 688.21)",
    strokeWidth: 1.7678
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.7678
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.331 0 0 1.331 799.8 -1214.7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5 0 0 .5 -1617.5 688.21)",
    strokeWidth: 1.7678
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.7678
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.331 0 0 1.331 767.06 -1222.9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5 0 0 .5 -1617.5 688.21)",
    strokeWidth: 1.7678
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.7678
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.331 0 0 1.331 783.43 -1217.9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5 0 0 .5 -1617.5 688.21)",
    strokeWidth: 1.7678
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.7678
  }))))), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.1765
  }, /*#__PURE__*/React.createElement("path", {
    d: "m358.41 213.62c-9.0186 2.0007-18.587 5.9746-26.125 13.438-6.9868 6.9175-11.634 15.083-14.312 25-2.507 9.2816-2.5832 14.802-1.4688 24.045 1.434 11.893 8.75 23.83 8.75 23.83l12.611-2.25s-7.5991-16.016-8.4545-23.111c-1.0276-8.5228-.99559-11.257 1.125-19.108 2.1967-8.1331 5.3862-13.722 10.875-19.156 5.1768-5.1254 12.469-8.3005 19.938-10.031 6.6614-1.5437 14.188-2.2045 20.031-1 11.099 2.2879 18.309 5.9114 30.375 9.7188 8.7034 2.7464 15.356 3.688 24.156 4.1875 5.3829.30553 11.605-1.0373 17.438-2.2812s10.719-2.5312 10.719-2.5312l-3.2812-12.594s-4.6615 1.2344-10.156 2.4062-12.358 2.1227-13.969 2.0312c-8.297-.47093-13.168-1.1633-20.969-3.625-11.169-3.5243-19.074-7.4316-31.688-10.062-8.4994-1.7728-17.217-.76456-25.594 1.0938z",
    color: "#000000",
    fill: "#fed100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m358.41 213.62c-9.0186 2.0007-18.587 5.9746-26.125 13.438-6.9868 6.9175-11.634 15.083-14.312 25-2.507 9.2816-2.5832 14.802-1.4688 24.045 1.434 11.893 8.75 23.83 8.75 23.83l12.611-2.25s-7.5991-16.016-8.4545-23.111c-1.0276-8.5228-.99559-11.257 1.125-19.108 2.1967-8.1331 5.3862-13.722 10.875-19.156 5.1768-5.1254 12.469-8.3005 19.938-10.031 6.6614-1.5437 14.188-2.2045 20.031-1 11.099 2.2879 18.309 5.9114 30.375 9.7188 8.7034 2.7464 15.356 3.688 24.156 4.1875 5.3829.30553 11.605-1.0373 17.438-2.2812s10.719-2.5312 10.719-2.5312l-3.2812-12.594s-4.6615 1.2344-10.156 2.4062-12.358 2.1227-13.969 2.0312c-8.297-.47093-13.168-1.1633-20.969-3.625-11.169-3.5243-19.074-7.4316-31.688-10.062-8.4994-1.7728-17.217-.76456-25.594 1.0938z",
    color: "#000000",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.1765
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.88389
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.331 0 0 1.331 679.36 -1151.1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5 0 0 .5 -1617.5 688.21)",
    strokeWidth: 1.7678
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.7678
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.331 0 0 1.331 676 -1167.8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5 0 0 .5 -1617.5 688.21)",
    strokeWidth: 1.7678
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.7678
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.331 0 0 1.331 677.01 -1185.6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5 0 0 .5 -1617.5 688.21)",
    strokeWidth: 1.7678
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.7678
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.331 0 0 1.331 683.83 -1202.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5 0 0 .5 -1617.5 688.21)",
    strokeWidth: 1.7678
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.7678
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.331 0 0 1.331 696.57 -1215.6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5 0 0 .5 -1617.5 688.21)",
    strokeWidth: 1.7678
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.7678
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.331 0 0 1.331 712.48 -1224.2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5 0 0 .5 -1617.5 688.21)",
    strokeWidth: 1.7678
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.7678
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.331 0 0 1.331 730.67 -1228.8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5 0 0 .5 -1617.5 688.21)",
    strokeWidth: 1.7678
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.7678
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.331 0 0 1.331 749.32 -1227.9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5 0 0 .5 -1617.5 688.21)",
    strokeWidth: 1.7678
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.7678
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.331 0 0 1.331 799.8 -1214.7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5 0 0 .5 -1617.5 688.21)",
    strokeWidth: 1.7678
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.7678
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.331 0 0 1.331 767.06 -1222.9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5 0 0 .5 -1617.5 688.21)",
    strokeWidth: 1.7678
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.7678
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.331 0 0 1.331 783.43 -1217.9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5 0 0 .5 -1617.5 688.21)",
    strokeWidth: 1.7678
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.7678
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.4e-6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.21 0 0 1.21 213.62 155.72)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.97228
  }, /*#__PURE__*/React.createElement("path", {
    d: "m185.96 37.047c1.5672-1.9839 3.4392-3.4577 4.9565-5.4749 1.5941-2.1194 2.8103-4.7978 3.4354-7.503-2.771.69088-5.4494 1.9071-7.5688 3.5011-2.0172 1.5172-3.491 3.3892-5.4749 4.9565v-25.411c1.9839 1.5672 3.4577 3.4392 5.4749 4.9565 2.1194 1.5941 4.7978 2.8103 7.5688 3.5011-.62508-2.7052-1.8413-5.3836-3.4354-7.503-1.5172-2.0173-3.3892-3.491-4.9565-5.4749l28.152 9e-7c-1.5672 1.9839-3.4392 3.4577-4.9565 5.4749-1.5941 2.1194-2.8103 4.7978-3.4354 7.503 2.771-.69088 5.4494-1.9071 7.5688-3.5011 2.0172-1.5172 3.491-3.3892 5.4749-4.9565v25.411c-1.9839-1.5672-3.4577-3.4392-5.4749-4.9565-2.1194-1.5941-4.7978-2.8103-7.5688-3.5011.62508 2.7052 1.8413 5.3836 3.4354 7.503 1.5172 2.0173 3.3892 3.491 4.9565 5.4749z",
    fill: "#fed100",
    stroke: "#000",
    strokeWidth: 0.97228
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.331 0 0 1.331 562.93 -1417.2)",
    strokeWidth: 0.73049
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5 0 0 .5 -1617.5 688.21)",
    strokeWidth: 1.461
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.461
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.94311 0 0 .94311 266.87 172.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.8635 0 0 1.8334 97.192 -1597.7)",
    strokeWidth: 0.67487
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.04 0 0 1.04 -2741.9 82.476)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fed100"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.04 0 0 1.04 -2741.9 82.476)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.64894
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.2474
  }, /*#__PURE__*/React.createElement("path", {
    d: "m195.84 28.438v17.062h-17.062v8.6875h42.812v-8.6875h-17.094v-17.062z",
    fill: "#fed100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.84 28.437v17.062h-17.062v8.6875h42.812v-8.6875h-17.094v-17.062z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.2474
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(299.98 6.6836)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-39.304 193.4)",
    strokeWidth: 1.1765
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 182.33,
    y: 34.934,
    width: 25.322,
    height: 71.72,
    ry: 6.386,
    fill: "#fed100",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.33,
    y: 34.934,
    width: 25.322,
    height: 71.72,
    ry: 6.386,
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.1765
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-303.37 -281.42)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.1536
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.147 0 0 .90673 226.84 -537.15)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.33,
    y: 941.22,
    width: 7.0406,
    height: 79.256,
    ry: 3.7999,
    fill: "#fed100",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224.85 941.22c1.9502 0 3.5203 1.6948 3.5203 3.7999v71.656c0 2.1051-1.57 3.7999-3.5203 3.7999s-3.5203-1.6948-3.5203-3.7999v-71.656c0-2.1052 1.57-3.7999 3.5203-3.7999z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.1536
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.147 0 0 .90673 232.09 -537.15)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 240.49,
    y: 941.22,
    width: 7.0406,
    height: 79.256,
    ry: 3.7999,
    fill: "#fed100",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.49,
    y: 941.22,
    width: 7.0406,
    height: 79.256,
    ry: 3.7999,
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.1536
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25.575 194.49)",
    strokeWidth: 0.88389
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.331 0 0 1.331 544.15 -1401.7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5 0 0 .5 -1617.5 688.21)",
    strokeWidth: 1.7678
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.7678
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.331 0 0 1.331 544.15 -1387.6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5 0 0 .5 -1617.5 688.21)",
    strokeWidth: 1.7678
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.7678
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.331 0 0 1.331 544.15 -1373.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5 0 0 .5 -1617.5 688.21)",
    strokeWidth: 1.7678
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.7678
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.331 0 0 1.331 544.15 -1359.3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5 0 0 .5 -1617.5 688.21)",
    strokeWidth: 1.7678
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.7678
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.331 0 0 1.331 544.15 -1345.2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5 0 0 .5 -1617.5 688.21)",
    strokeWidth: 1.7678
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.7678
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120.94 241.14)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(467.6 -914.69)",
    strokeWidth: 1.1765
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5e-6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-147.29 1086.9c-6.7196 15.023-12.101 29.69-17.375 44.782h-216.62c-5.0982-14.589-10.297-30.282-16.708-44.782 0 0 13.482 18.865 23.578 23.427 5.6081 2.5339 12.623 3.2894 18.421 1.228 7.6415-2.7166 17.807-16.579 17.807-16.579s9.1411 10.698 15.351 13.509c5.8285 2.6378 12.644 2.745 19.035 2.4561 5.6554-.2556 11.92-.4688 16.579-3.6842 7.0552-4.8687 14.123-21.491 14.123-21.491s6.8378 13.078 12.281 17.807c4.4913 3.9023 10.131 6.8156 15.965 7.9824 5.8342 1.1668 12.21.7899 17.807-1.228 7.5879-2.7357 19.649-14.123 19.649-14.123s8.3017 10.296 14.123 12.895c5.6351 2.5153 12.414 3.2557 18.421 1.8421 6.3568-1.496 11.698-6.1001 16.579-10.439 4.3566-3.8723 10.988-13.602 10.988-13.602z",
    fill: "#fed100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-147.29 1086.9c-6.7196 15.023-12.101 29.69-17.375 44.782h-216.62c-5.0982-14.589-10.297-30.282-16.708-44.782 0 0 13.482 18.865 23.578 23.427 5.6081 2.5339 12.623 3.2894 18.421 1.228 7.6415-2.7166 17.807-16.579 17.807-16.579s9.1411 10.698 15.351 13.509c5.8285 2.6378 12.644 2.745 19.035 2.4561 5.6554-.2556 11.92-.4688 16.579-3.6842 7.0552-4.8687 14.123-21.491 14.123-21.491s6.8378 13.078 12.281 17.807c4.4913 3.9023 10.131 6.8156 15.965 7.9824 5.8342 1.1668 12.21.7899 17.807-1.228 7.5879-2.7357 19.649-14.123 19.649-14.123s8.3017 10.296 14.123 12.895c5.6351 2.5153 12.414 3.2557 18.421 1.8421 6.3568-1.496 11.698-6.1001 16.579-10.439 4.3566-3.8723 10.988-13.602 10.988-13.602z",
    fill: "none",
    stroke: "#000"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fed100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-272.65 1095.5s-4.9394 7.6033-7.9767 10.201c-4.2181 3.6078-6.9924 5.7811-12.411 7.4891-5.4087 1.7051-12.953 2.664-18.616 2.3538-5.4768-.3001-11.112-1.888-16.048-4.2795-4.2906-2.0787-11.127-8.1311-11.127-8.1311-3.3232 4.3118-7.5549 7.3405-11.583 9.5786-5.1507 2.8622-10.24 3.1201-15.586 2.832-10.867-.5858-21.005-7.3742-29.137-21.138-5.2727-12.47-11.338-25.099-18.912-38.342 8.7295-3.0896 18.903-4.7355 30.187-5.2706-4.5894 12.931-9.3504 25.528-7.6664 35.936 9.4806-7.1005 12.547-16.767 15.812-26.354l11.021 38.812c-6.6889-1.1728-3.1317-2.555-20.698-5.8849 3.5198 6.6368 11.578 14.832 20.462 15.639 5.9737.5425 10.31-1.3029 14.107-4.5963 2.7277-2.3659 5.2149-5.4949 5.1822-9.0197-.0187-2.0187-.0375-4.0374-.0562-6.0561-.012-1.2969-1.6125-3.1325-2.9094-3.1507-1.2358-.017-1.5777 1.9883-1.9076 3.1793-.66009 2.3832.66538 5.0369 0 7.4186-.73358 2.6258-2.1408 4.6993-4.4511 6.1467-1.9243 1.2057-6.5707 1.4838-6.5707 1.4838l1.4837-5.7229c1.0467-4.0374-2.8724-7.1709-3.8152-11.234-.60694-2.6153-.94144-5.5401 0-8.0544 1.0185-2.7201 3.0793-5.3675 5.7229-6.5707.96458-.439 2.1222-.499 3.1794-.4239 1.495.1062 4.4511 1.0598 4.4511 1.0598s-.84834-4.0909-.63587-6.5707c.25766-3.0073 2.805-8.578 4.2392-11.234 2.3814-4.41 6.1684-8.3832 6.6002-8.8102.41467.4172 4.5196 4.2377 7.2021 8.4713 1.6155 2.5496 3.2724 6.2339 3.7387 9.216.38449 2.459.24673 7.6588.24673 7.6588s4.3663-1.7928 5.8503-2.0028c1.0493-.1485 2.2084-.1692 3.2012.2017 2.7209 1.0164 4.9609 3.514 6.1662 6.1566 1.1141 2.4428.98388 5.3837.56036 8.0349-.65795 4.1187-3.0778 7.3053-1.7527 11.26l1.8782 5.6058s-4.6545.046-6.658-1.023c-2.4054-1.2833-3.9535-3.2539-4.868-5.8222-.82946-2.3296-.34811-5.1826-1.7879-7.1886-.63699-.8876-1.5285-1.8705-2.7601-1.7672-1.2925.1083-2.1999 2.2199-2.2542 3.5158l-.22864 5.4514c-.0702 1.6747.69287 3.4155 1.5896 4.7706 2.1974 3.3204 5.4675 5.3345 9.1576 6.8299 3.9967 1.6197 7.6011 2.2423 11.913 2.2927 3.5974.042 9.8497-.5472 13.258-1.6988 4.1991-1.4186 6.669-3.2207 9.9175-6.236 1.831-1.6996 3.0546-4.1683 3.8604-6.533.92812-2.7236.59391-7.4239.59391-7.4239-4.1784 1.5837-7.8112 3.7129-11.086 6.2006-3.7006 2.8115-6.9433 6.0809-9.9982 9.538l-.29696-46.919c4.3526 4.8016 7.5174 9.1023 11.87 12.718 3.6652 3.0451 5.5486 4.2065 9.2138 5.3958-1.047-3.7744-1.4007-6.064-4.1031-9.8384-3.7469-5.2332-7.3959-10.852-11.932-16.086 8.3534-1.3911 16.702-1.7662 25.167-1.7662 8.4647 0 16.813.3751 25.167 1.7662-4.5366 5.2332-8.1856 10.852-11.932 16.086-2.7024 3.7744-3.0561 6.064-4.1031 9.8384 3.6652-1.1893 5.5486-2.3507 9.2138-5.3958 4.3526-3.6162 7.5174-7.9169 11.87-12.718l-.29696 46.919c-3.0549-3.4571-6.2976-6.7265-9.9982-9.538-3.2744-2.4877-6.9073-4.6169-11.086-6.2006 0 0-.33421 4.7003.59391 7.4239.80584 2.3647 2.0294 4.8334 3.8604 6.533 3.2485 3.0153 5.7184 4.8174 9.9175 6.236 3.4084 1.1516 9.6607 1.7408 13.258 1.6988 4.3121-.05 7.9165-.673 11.913-2.2927 3.6901-1.4954 6.9603-3.5095 9.1576-6.8299.89676-1.3551 1.6598-3.0959 1.5896-4.7706l-.22864-5.4514c-.0543-1.2959-.96175-3.4075-2.2542-3.5158-1.2316-.1033-2.1231.8796-2.7601 1.7672-1.4398 2.006-.95841 4.859-1.7879 7.1886-.91448 2.5683-2.4626 4.5389-4.868 5.8222-2.0035 1.0689-6.658 1.023-6.658 1.023l1.8782-5.6058c1.3251-3.9548-1.0948-7.1414-1.7527-11.26-.42352-2.6512-.55373-5.5921.56036-8.0349 1.2052-2.6426 3.4453-5.1402 6.1662-6.1566.99278-.3709 2.1518-.3502 3.2012-.2017 1.484.21 5.8503 2.0028 5.8503 2.0028s-.13776-5.1998.24673-7.6588c.46625-2.9821 2.1232-6.6664 3.7387-9.216 2.6825-4.2336 6.7874-8.0541 7.2021-8.4713.43186.427 4.2188 4.4002 6.6002 8.8102 1.4342 2.6558 3.9815 8.2265 4.2392 11.234.21247 2.4798-.63587 6.5707-.63587 6.5707s2.9561-.9536 4.4511-1.0598c1.0571-.075 2.2148-.015 3.1794.4239 2.6436 1.2032 4.7044 3.8506 5.7229 6.5707.94144 2.5143.60694 5.4391 0 8.0544-.9429 4.0629-4.862 7.1964-3.8152 11.234l1.4837 5.7229s-4.6464-.2781-6.5707-1.4838c-2.3103-1.4474-3.7176-3.5209-4.4511-6.1467-.66538-2.3817.66009-5.0354 0-7.4186-.32991-1.191-.67182-3.1966-1.9076-3.1793-1.2969.018-2.8974 1.8538-2.9094 3.1507-.0187 2.0187-.0375 4.0374-.0562 6.0561-.0327 3.5248 2.4546 6.6538 5.1822 9.0197 3.7971 3.2934 8.1332 5.1388 14.107 4.5963 8.8838-.8067 16.942-9.0022 20.462-15.639-17.566 3.3299-14.009 4.7121-20.698 5.8849l11.021-38.812c3.2649 9.5868 6.3314 19.253 15.812 26.354 1.684-10.409-3.0771-23.006-7.6664-35.936 11.284.5351 21.457 2.181 30.187 5.2706-7.574 13.242-13.639 25.871-18.912 38.342-8.132 13.764-18.27 20.552-29.137 21.138-5.3463.2881-10.435.03-15.586-2.832-4.0277-2.2381-8.2594-5.2668-11.583-9.5786 0 0-6.8361 6.0524-11.127 8.1311-4.9362 2.3915-10.571 3.9794-16.048 4.2795-5.6626.3102-13.207-.6487-18.616-2.3538-5.4181-1.708-8.1925-3.8813-12.411-7.4891-3.0373-2.5978-7.9768-10.201-7.9768-10.201z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-365.99 1115.5c-10.867-.5858-21.005-7.3742-29.137-21.138-5.2727-12.47-11.338-25.099-18.912-38.342 8.7295-3.0896 18.903-4.7355 30.187-5.2706-4.5894 12.931-9.3504 25.528-7.6664 35.936 9.4806-7.1005 12.547-16.767 15.812-26.354l11.021 38.812c-6.6889-1.1728-3.1317-2.555-20.698-5.8849 3.5198 6.6368 11.578 14.832 20.462 15.639zm185.62-6.6014c8.8838-.8067 16.942-9.0022 20.462-15.639-17.566 3.3299-14.009 4.7121-20.698 5.8849l11.021-38.812c3.2649 9.5868 6.3314 19.253 15.812 26.354 1.684-10.409-3.0771-23.006-7.6664-35.936 11.284.5351 21.457 2.181 30.187 5.2706-7.574 13.242-13.639 25.871-18.912 38.342-8.132 13.764-18.27 20.552-29.137 21.138l-.20811.3835z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-311.65 1115.5c-5.4768-.3001-11.112-1.888-16.048-4.2795-4.2906-2.0787-11.127-8.1311-11.127-8.1311-3.3232 4.3118-7.5549 7.3405-11.583 9.5786-5.1507 2.8622-10.24 3.1201-15.586 2.832l-.18752 1.8729 1.2556-8.4743c5.9737.5425 10.31-1.3029 14.107-4.5963 2.7277-2.3659 5.2149-5.4949 5.1822-9.0197-.0187-2.0187-.0375-4.0374-.0562-6.0561-.012-1.2969-1.6125-3.1325-2.9094-3.1507-1.2358-.017-1.5777 1.9883-1.9076 3.1793-.66009 2.3832.66538 5.0369 0 7.4186-.73358 2.6258-2.1408 4.6993-4.4511 6.1467-1.9243 1.2057-6.5707 1.4838-6.5707 1.4838l1.4837-5.7229c1.0467-4.0374-2.8724-7.1709-3.8152-11.234-.60694-2.6153-.94144-5.5401 0-8.0544 1.0185-2.7201 3.0793-5.3675 5.7229-6.5707.96458-.439 2.1222-.499 3.1794-.4239 1.495.1062 4.4511 1.0598 4.4511 1.0598s-.84834-4.0909-.63587-6.5707c.25766-3.0073 2.805-8.578 4.2392-11.234 2.3814-4.41 6.1684-8.3832 6.6002-8.8102.41467.4172 4.5196 4.2377 7.2021 8.4713 1.6155 2.5496 3.2724 6.2339 3.7387 9.216.38449 2.459.24673 7.6588.24673 7.6588s4.3663-1.7928 5.8503-2.0028c1.0493-.1485 2.2084-.1692 3.2012.2017 2.7209 1.0164 4.9609 3.514 6.1662 6.1566 1.1141 2.4428.98388 5.3837.56036 8.0349-.65795 4.1187-3.0778 7.3053-1.7527 11.26l1.8782 5.6058s-4.6545.046-6.658-1.023c-2.4054-1.2833-3.9535-3.2539-4.868-5.8222-.82946-2.3296-.34811-5.1826-1.7879-7.1886-.63699-.8876-1.5285-1.8705-2.7601-1.7672-1.2925.1083-2.1999 2.2199-2.2542 3.5158l-.22864 5.4514c-.0702 1.6747.69287 3.4155 1.5896 4.7706 2.1974 3.3204 5.4675 5.3345 9.1576 6.8299 3.9967 1.6197 7.6011 2.2423 11.913 2.2927z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m-203.85 1095.1-.12597-.2106c-.15092-2.5694.71875-6.9687.71875-6.9687.48416-2.19 2.3616-4.533 4.6875-5.375 1.2538-.4542 2.7761-.6286 4.125.031.82261.4023 1.4858.7143 2.0312 1.2812.54546.567.88412 1.3124 1.25 2.375.53493 1.5537.30202 3.1738.0312 4.5626-.44672 2.2906-.39733 4.2935.25 5.8437.45703 1.0945 1.3768 1.9155 2.5625 2.625-.22033-.7834-.37923-1.1628-.5-2.0313-.17901-1.2874.0385-2.6168.53125-3.7812.85831-2.0281 2.0429-3.6268 2.8438-5.4062.76379-1.6972 1.1633-3.6202 1.0312-5.4376-.10893-1.4991-.55191-3.0476-1.4062-4.125-.92643-1.1682-2.3398-2.1368-3.75-2.4062-1.2546-.2397-3.3154.1873-4.9688.7188-1.6534.5314-2.9062 1.125-2.9062 1.125l-1.4688.6874.25-1.5937c.85923-5.3602 1.6184-8.0814 0-13.094-.66543-2.0609-1.7767-4.334-3.6562-6.9688-.91278-1.2796-1.932-2.8073-3.0938-4.2188-3.028 3.4471-5.1387 6.9398-6.3438 10.469-1.3192 3.8634-1.3714 8.9997-1.0625 13.125l.125 1.6562-1.4062-.8437s-1.5988-.9804-3.5312-1.9063c-1.9325-.9258-4.2874-1.7432-5.2812-1.6562-1.8738.1642-3.1245 1.0598-4.3438 2.625-1.0348 1.3285-1.2578 2.4801-1.4688 4.3125-.13326 1.1576.15826 3.3345.34375 4.75.21737 1.6588 1.194 3.4032 1.4688 5.5.0908.6926.30568 1.237.46875 1.9063.16307.6692.24456 1.4547.0625 2.375-.12584.6361-.31363 1.0959-.5625 1.875.4794-.2326.80884-.349 1.0625-.5313.92721-.6662 1.3036-1.8481 1.9062-3.2813.32438-.7714.3958-1.4641.4375-2.2812s.082-1.7776.5-2.8438c.71403-1.8212 1.5543-3.9841 3.4062-5.3124 1.516-1.0874 3.5384-1.3901 5.3125-.8438 1.0511.3237 1.8031.9723 2.3438 1.7188.54068.7464.9035 1.5624 1.2812 2.375.48369 1.0404.77286 2.5972 1 3.9687s.34375 2.5313.34375 2.5313l.0312.125-.0312.1562-1.2912 4.2919-1.6462-.371 1.25-4.1044c-.009-.08-.13324-1.0727-.34375-2.3437-.21876-1.3209-.54916-2.8976-.84375-3.5313-.38681-.832-.73471-1.5549-1.125-2.0937-.39029-.5389-.78661-.8838-1.4688-1.0938-1.2234-.3767-2.8111-.1469-3.8438.5938-1.3109.9402-2.1058 2.7599-2.8125 4.5624-.3069.7828-.3329 1.4876-.375 2.3126-.0421.8249-.0859 1.7845-.53125 2.8437-.55178 1.3122-1.0086 2.9284-2.5 4-1.099.7897-3.0938 1.5625-3.0938 1.5625l-1.75.7188.625-1.7813s.88084-2.613 1.0625-3.5313c.12572-.6355.0743-1.0946-.0625-1.6562-.13684-.5616-.3847-1.2139-.5-2.0938-.21737-1.6587-1.194-3.4031-1.4688-5.5-.17909-1.3665-.53139-3.5264-.34375-5.1562.21885-1.901.53791-3.5512 1.8125-5.1875 1.3961-1.7922 3.1655-3.0426 5.5312-3.25 1.8698-.1639 4.1696.8457 6.1875 1.8125 1.2979.6219 1.6923.9079 2.3438 1.2812-.21156-3.9597-.14729-8.5263 1.1562-12.344 1.382-4.0471 3.7495-8.0364 7.3438-11.906l.625-.6562.625.6562c1.6705 1.7979 2.812 3.7724 3.8438 5.2188 1.9668 2.757 3.1845 5.2023 3.9062 7.4375 1.5461 4.7882.97906 8.0566.25 12.469.56903-.2397.76782-.3717 1.75-.6874 1.7674-.5682 3.922-1.1053 5.7812-.75 1.9006.3631 3.6133 1.5272 4.7812 3 1.1593 1.4618 1.6553 3.3294 1.7812 5.0624.15624 2.1503-.31869 4.3508-1.1875 6.2813-.8989 1.9973-2.0879 3.5889-2.8438 5.375-.3806.8994-.56713 1.9427-.4375 2.875.19405 1.3955.9375 3.6563.9375 3.6563l.53125 1.5937-1.625-.5313c-2.5939-.8801-4.292-2.4739-5.125-4.4687s-.82906-4.3239-.34375-6.8125c.25477-1.3067.39044-2.6129.0312-3.6562-.33243-.9655-.57462-1.4378-.875-1.75-.30038-.3123-.76208-.5461-1.5625-.9376-.73896-.3616-1.881-.3063-2.8125.031-1.5454.5595-3.3949 2.6275-3.5625 4.0937-.29599 2.5891-1.0311 5.2222-2.2802 6.8634zm48.749-3.0516.4375-.875-.9375-.3126c-6.9794-2.2099-13.424-.5376-19.5 2.0313 2.4556-6.7087 4.3257-13.41 5.6562-20.125 6.6246 11.903 12.246 15.797 17.531 18.219l.96875.4376.21875-1.0626c1.5767-8.1269 1.6991-18.955-4.9688-35.062 7.4719.388 14.902 1.2839 22.281 4.5624l.6875-1.5624c-8.1013-3.5995-16.194-4.4939-24.188-4.8438l-1.375-.062.5625 1.25c6.8477 15.896 6.8487 26.242 5.4688 34.219-5.0785-2.4715-10.219-6.2041-16.781-18.719l-1.1562-2.1875-.4375 2.4375c-1.4254 7.8888-3.6496 15.789-6.6562 23.688l-.75 1.9375 1.875-.875c6.1366-2.7847 12.342-4.5981 19.031-2.8437l.16479.1033zm-233.06.2499c6.6798-1.7432 12.871.062 19 2.8437l1.875.875-.71875-1.9369c-3.0067-7.8982-5.2309-15.799-6.6562-23.688l-.4375-2.4375-1.1562 2.1875c-6.5652 12.52-11.732 16.247-16.812 18.719-1.3799-7.9764-1.3477-18.322 5.5-34.219l.53125-1.25-1.3438.062c-7.9939.3499-16.086 1.2443-24.188 4.8438l.6875 1.5624c7.3882-3.2825 14.8-4.1753 22.281-4.5624-6.6683 16.108-6.5455 26.935-4.9688 35.062l.1875 1.0626 1-.4376c5.2817-2.4203 10.913-6.3045 17.531-18.187 1.3302 6.7036 3.205 13.397 5.6562 20.094-6.076-2.5689-12.521-4.2412-19.5-2.0313l-.9375.3126.4375.875-.18112.091 2.2124.1594zm54.883 3.778-.97714-3.6524c.0174-.1541.11063-1.0311.3125-2.25.21876-1.3209.58041-2.8976.875-3.5313.38681-.832.73471-1.5549 1.125-2.0937.39029-.5389.78661-.8838 1.4688-1.0938 1.2234-.3767 2.7798-.1469 3.8125.5938 1.3109.9402 2.1371 2.7599 2.8438 4.5624.30688.7828.33289 1.4876.375 2.3126.0421.8249.0859 1.7845.53125 2.8437.55178 1.3122 1.0086 2.9284 2.5 4 1.099.7897 3.0938 1.5625 3.0938 1.5625l1.7188.7188-.59375-1.7813s-.88084-2.613-1.0625-3.5313c-.12572-.6355-.0743-1.0946.0625-1.6562.13684-.5616.35345-1.2139.46875-2.0938.21737-1.6587 1.194-3.4031 1.4688-5.5.17909-1.3665.56264-3.5264.375-5.1562-.21885-1.901-.53791-3.5512-1.8125-5.1875-1.3961-1.7922-3.1655-3.0426-5.5312-3.25-1.8698-.1639-4.1696.8457-6.1875 1.8125-1.2979.6219-1.6923.9079-2.3438 1.2812.21156-3.9597.14729-8.5263-1.1562-12.344-1.382-4.0471-3.7495-8.0364-7.3438-11.906l-.625-.6562-.625.6562c-1.6705 1.7979-2.8432 3.7724-3.875 5.2188-1.9668 2.757-3.1533 5.2023-3.875 7.4375-1.5461 4.7882-.97906 8.0566-.25 12.469-.56888-.24-.75927-.369-1.75-.6874-1.7674-.5682-3.922-1.1053-5.7812-.75-1.9006.3631-3.6133 1.5272-4.7812 3-1.1593 1.4618-1.6553 3.3294-1.7812 5.0624-.15624 2.1503.31869 4.3508 1.1875 6.2813.8989 1.9973 2.0879 3.5889 2.8438 5.375.38062.8994.53588 1.9427.40625 2.875-.19405 1.3955-.90625 3.6562-.90625 3.6563l-.53125 1.5937 1.625-.5313c2.5939-.8801 4.292-2.4739 5.125-4.4687s.82906-4.3239.34375-6.8125c-.25482-1.3067-.39049-2.6129-.0312-3.6562.33243-.9655.57462-1.4378.875-1.75.30038-.3123.73083-.5461 1.5312-.9376.73896-.3613 1.9122-.306 2.8438.031 1.5454.5595 3.2311 2.6503 3.5625 4.0937 0 0-4e-5.031 0 .031.008.042.80629 4.5089.6875 6.5313l2.0056.3547c-.16714-2.8298-1.0368-7.2291-1.0368-7.2291-.48416-2.19-2.3303-4.533-4.6562-5.375-1.2538-.454-2.8074-.6284-4.1562.031-.82261.4023-1.4545.7143-2 1.2812-.54546.567-.91537 1.3124-1.2812 2.375-.53498 1.5537-.30207 3.1738-.0312 4.5626.44672 2.2906.39733 4.2935-.25 5.8437-.45703 1.0945-1.3456 1.9155-2.5312 2.625.22033-.7834.37923-1.1628.5-2.0313.17901-1.2874-.0385-2.6168-.53125-3.7812-.85831-2.0281-2.0429-3.6268-2.8438-5.4062-.76379-1.6972-1.1946-3.6202-1.0625-5.4376.10893-1.4991.55191-3.0476 1.4062-4.125.92643-1.1682 2.3711-2.1368 3.7812-2.4062 1.2546-.2397 3.2841.1873 4.9375.7188 1.6534.5314 2.9375 1.125 2.9375 1.125l1.4688.6874-.28125-1.5937c-.85923-5.3602-1.5872-8.0814.0312-13.094.66543-2.0609 1.7454-4.334 3.625-6.9688.91332-1.2803 1.9623-2.8066 3.125-4.2188 3.0269 3.4463 5.1389 6.9405 6.3438 10.469 1.3192 3.8634 1.3401 8.9997 1.0312 13.125l-.0937 1.6562 1.4062-.8437s1.5675-.9804 3.5-1.9063c1.9325-.9258 4.3186-1.7433 5.3125-1.6562 1.8738.1642 3.1245 1.0598 4.3438 2.625 1.0348 1.3285 1.2578 2.4801 1.4688 4.3125.13326 1.1576-.18951 3.3345-.375 4.75-.21737 1.6588-1.1627 3.4032-1.4375 5.5-.0908.6926-.30568 1.237-.46875 1.9063-.16307.6692-.27581 1.4547-.0937 2.375.12584.6361.31363 1.0959.5625 1.875-.4794-.2326-.80884-.349-1.0625-.5313-.92721-.6662-1.3036-1.8481-1.9062-3.2813-.32438-.7714-.36454-1.4641-.40625-2.2812-.0417-.8171-.082-1.7776-.5-2.8438-.71403-1.8212-1.5543-3.9841-3.4062-5.3124-1.516-1.0874-3.5384-1.3901-5.3125-.8438-1.0511.3237-1.8343.9723-2.375 1.7188-.54068.7464-.87225 1.5624-1.25 2.375-.48369 1.0404-.77286 2.5972-1 3.9687s-.375 2.5312-.375 2.5313v.125l.0312.1562 1.0084 3.7462.49726.054 1.1589-.4284zm64.679-13.84.0312-1.0624 1.0312.25c4.755 1.1922 8.3902 2.8033 11.406 4.5937 3.8268 2.2716 6.6528 4.8219 9.625 7.2813l.5-28.219c-2.5327 2.7962-4.9097 5.7915-8.4062 8.1875-2.8555 1.9568-8.2095 4.5285-13.219 5.0937l-1.1875.125.25-1.1562c.70513-3.1804.68458-5.3889 2.2812-9.1562 1.5147-3.5739 4.7084-8.7569 11.062-17.438-5.4954-.6072-10.283-1.2812-17.438-1.2812-7.1521 0-11.913.6741-17.406 1.2812 6.3541 8.6807 9.5478 13.864 11.062 17.438 1.5967 3.7673 1.5761 5.9758 2.2812 9.1562l.25 1.1562-1.1875-.125c-5.0092-.5652-10.363-3.1369-13.219-5.0937-3.483-2.3867-5.8846-5.369-8.4062-8.1563l.5 28.156c2.9599-2.451 5.8126-4.987 9.625-7.25 3.0161-1.7904 6.62-3.4015 11.375-4.5937l1.0625-.25v1.0624l-1.7128 1.1975c-4.0153 1.1313-7.2253 2.4949-9.8498 4.0527-4.203 2.4949-7.2401 5.4082-10.812 8.25l-1.3438 1.0626-.0312-1.7188-.53125-32.188-.0625-2.125 1.5 1.5c3.2981 3.326 5.7705 6.9524 9.625 9.5937 2.3766 1.6287 7.0366 3.8066 11.312 4.5626-.47638-2.5632-.68619-4.5676-1.9688-7.5938-1.5022-3.5445-4.595-8.7401-11.656-18.281l-.875-1.1876 1.4688-.1562c6.0848-.6306 11.105-1.4688 19-1.4688l1e-4 6e-4c7.8948 0 12.915.8382 19 1.4688l1.5.1562-.875 1.1876c-7.0612 9.5411-10.185 14.737-11.688 18.281-1.2871 3.0368-1.4571 5.0479-1.9375 7.625 4.2776-.7549 8.9035-2.9643 11.281-4.5938 3.8545-2.6413 6.3582-6.2677 9.6562-9.5937l1.4688-1.5-.0312 2.125-.5625 32.188v1.7188l-1.375-1.0626c-3.5724-2.8418-6.5782-5.7551-10.781-8.25-2.6244-1.5578-5.8345-2.9214-9.8438-4.0312z",
    color: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-272.65 1095.5s-4.9394 7.6033-7.9767 10.201c-4.2181 3.6078-6.9924 5.7811-12.411 7.4891-5.4087 1.7051-12.953 2.664-18.616 2.3538-5.4768-.3001-11.112-1.888-16.048-4.2795-4.2906-2.0787-11.127-8.1311-11.127-8.1311-3.3232 4.3118-7.5549 7.3405-11.583 9.5786-5.1507 2.8622-10.24 3.1201-15.586 2.832-10.867-.5858-21.005-7.3742-29.137-21.138-5.2727-12.47-11.338-25.099-18.912-38.342 8.7295-3.0896 18.903-4.7355 30.187-5.2706-4.5894 12.931-9.3504 25.528-7.6664 35.936 9.4806-7.1005 12.547-16.767 15.812-26.354l11.021 38.812c-6.6889-1.1728-3.1317-2.555-20.698-5.8849 3.5198 6.6368 11.578 14.832 20.462 15.639 5.9737.5425 10.31-1.3029 14.107-4.5963 2.7277-2.3659 5.2149-5.4949 5.1822-9.0197-.0187-2.0187-.0375-4.0374-.0562-6.0561-.012-1.2969-1.6125-3.1325-2.9094-3.1507-1.2358-.017-1.5777 1.9883-1.9076 3.1793-.66009 2.3832.66538 5.0369 0 7.4186-.73358 2.6258-2.1408 4.6993-4.4511 6.1467-1.9243 1.2057-6.5707 1.4838-6.5707 1.4838l1.4837-5.7229c1.0467-4.0374-2.8724-7.1709-3.8152-11.234-.60694-2.6153-.94144-5.5401 0-8.0544 1.0185-2.7201 3.0793-5.3675 5.7229-6.5707.96458-.439 2.1222-.499 3.1794-.4239 1.495.1062 4.4511 1.0598 4.4511 1.0598s-.84834-4.0909-.63587-6.5707c.25766-3.0073 2.805-8.578 4.2392-11.234 2.3814-4.41 6.1684-8.3832 6.6002-8.8102.41467.4172 4.5196 4.2377 7.2021 8.4713 1.6155 2.5496 3.2724 6.2339 3.7387 9.216.38449 2.459.24673 7.6588.24673 7.6588s4.3663-1.7928 5.8503-2.0028c1.0493-.1485 2.2084-.1692 3.2012.2017 2.7209 1.0164 4.9609 3.514 6.1662 6.1566 1.1141 2.4428.98388 5.3837.56036 8.0349-.65795 4.1187-3.0778 7.3053-1.7527 11.26l1.8782 5.6058s-4.6545.046-6.658-1.023c-2.4054-1.2833-3.9535-3.2539-4.868-5.8222-.82946-2.3296-.34811-5.1826-1.7879-7.1886-.63699-.8876-1.5285-1.8705-2.7601-1.7672-1.2925.1083-2.1999 2.2199-2.2542 3.5158l-.22864 5.4514c-.0702 1.6747.69287 3.4155 1.5896 4.7706 2.1974 3.3204 5.4675 5.3345 9.1576 6.8299 3.9967 1.6197 7.6011 2.2423 11.913 2.2927 3.5974.042 9.8497-.5472 13.258-1.6988 4.1991-1.4186 6.669-3.2207 9.9175-6.236 1.831-1.6996 3.0546-4.1683 3.8604-6.533.92812-2.7236.59391-7.4239.59391-7.4239-4.1784 1.5837-7.8112 3.7129-11.086 6.2006-3.7006 2.8115-6.9433 6.0809-9.9982 9.538l-.29696-46.919c4.3526 4.8016 7.5174 9.1023 11.87 12.718 3.6652 3.0451 5.5486 4.2065 9.2138 5.3958-1.047-3.7744-1.4007-6.064-4.1031-9.8384-3.7469-5.2332-7.3959-10.852-11.932-16.086 8.3534-1.3911 16.702-1.7662 25.167-1.7662 8.4647 0 16.813.3751 25.167 1.7662-4.5366 5.2332-8.1856 10.852-11.932 16.086-2.7024 3.7744-3.0561 6.064-4.1031 9.8384 3.6652-1.1893 5.5486-2.3507 9.2138-5.3958 4.3526-3.6162 7.5174-7.9169 11.87-12.718l-.29696 46.919c-3.0549-3.4571-6.2976-6.7265-9.9982-9.538-3.2744-2.4877-6.9073-4.6169-11.086-6.2006 0 0-.33421 4.7003.59391 7.4239.80584 2.3647 2.0294 4.8334 3.8604 6.533 3.2485 3.0153 5.7184 4.8174 9.9175 6.236 3.4084 1.1516 9.6607 1.7408 13.258 1.6988 4.3121-.05 7.9165-.673 11.913-2.2927 3.6901-1.4954 6.9603-3.5095 9.1576-6.8299.89676-1.3551 1.6598-3.0959 1.5896-4.7706l-.22864-5.4514c-.0543-1.2959-.96175-3.4075-2.2542-3.5158-1.2316-.1033-2.1231.8796-2.7601 1.7672-1.4398 2.006-.95841 4.859-1.7879 7.1886-.91448 2.5683-2.4626 4.5389-4.868 5.8222-2.0035 1.0689-6.658 1.023-6.658 1.023l1.8782-5.6058c1.3251-3.9548-1.0948-7.1414-1.7527-11.26-.42352-2.6512-.55373-5.5921.56036-8.0349 1.2052-2.6426 3.4453-5.1402 6.1662-6.1566.99278-.3709 2.1518-.3502 3.2012-.2017 1.484.21 5.8503 2.0028 5.8503 2.0028s-.13776-5.1998.24673-7.6588c.46625-2.9821 2.1232-6.6664 3.7387-9.216 2.6825-4.2336 6.7874-8.0541 7.2021-8.4713.43186.427 4.2188 4.4002 6.6002 8.8102 1.4342 2.6558 3.9815 8.2265 4.2392 11.234.21247 2.4798-.63587 6.5707-.63587 6.5707s2.9561-.9536 4.4511-1.0598c1.0571-.075 2.2148-.015 3.1794.4239 2.6436 1.2032 4.7044 3.8506 5.7229 6.5707.94144 2.5143.60694 5.4391 0 8.0544-.9429 4.0629-4.862 7.1964-3.8152 11.234l1.4837 5.7229s-4.6464-.2781-6.5707-1.4838c-2.3103-1.4474-3.7176-3.5209-4.4511-6.1467-.66538-2.3817.66009-5.0354 0-7.4186-.32991-1.191-.67182-3.1966-1.9076-3.1793-1.2969.018-2.8974 1.8538-2.9094 3.1507-.0187 2.0187-.0375 4.0374-.0562 6.0561-.0327 3.5248 2.4546 6.6538 5.1822 9.0197 3.7971 3.2934 8.1332 5.1388 14.107 4.5963 8.8838-.8067 16.942-9.0022 20.462-15.639-17.566 3.3299-14.009 4.7121-20.698 5.8849l11.021-38.812c3.2649 9.5868 6.3314 19.253 15.812 26.354 1.684-10.409-3.0771-23.006-7.6664-35.936 11.284.5351 21.457 2.181 30.187 5.2706-7.574 13.242-13.639 25.871-18.912 38.342-8.132 13.764-18.27 20.552-29.137 21.138-5.3463.2881-10.435.03-15.586-2.832-4.0277-2.2381-8.2594-5.2668-11.583-9.5786 0 0-6.8361 6.0524-11.127 8.1311-4.9362 2.3915-10.571 3.9794-16.048 4.2795-5.6626.3102-13.207-.6487-18.616-2.3538-5.4181-1.708-8.1925-3.8813-12.411-7.4891-3.0373-2.5978-7.9768-10.201-7.9768-10.201z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.1765
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9e-6)",
    strokeWidth: 0.80354
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.4641 0 0 1.4641 594.14 -1415.8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5 0 0 .5 -1617.5 688.21)",
    strokeWidth: 1.6071
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.6071
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.4641 0 0 1.4641 472.65 -1405)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5 0 0 .5 -1617.5 688.21)",
    strokeWidth: 1.6071
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.6071
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.4641 0 0 1.4641 -82.739 -1405)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5 0 0 .5 -1617.5 688.21)",
    strokeWidth: 1.6071
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.6071
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(467.6 -914.69)",
    strokeWidth: 1.1765
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-3.1061 -337.06 1093.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-346.46 1090.7h16.902l2.1993 3.8065-2.1993 3.8064h-16.902l-2.7068-3.8064z",
    fill: "#fed100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-346.46 1090.7h16.902l2.1993 3.8065-2.1993 3.8064h-16.902l-2.7068-3.8064z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.1765
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.99853 -.054185 -.054185 .99853 -485.55 -16.657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-346.46 1090.7h16.902l2.1993 3.8065-2.1993 3.8064h-16.902l-2.7068-3.8064z",
    fill: "#f6e078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-346.46 1090.7h16.902l2.1993 3.8065-2.1993 3.8064h-16.902l-2.7068-3.8064z",
    fill: "#fed100",
    stroke: "#000",
    strokeWidth: 1.1765
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120.73 275.6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-301.8 -173.48)",
    strokeWidth: 1.1765
  }, /*#__PURE__*/React.createElement("path", {
    d: "m390.39 381.08s12.056-.88424 33.297-2.0834c21.242-1.1992 44-1.8289 55.609-1.8289h35.387c11.245 0 34.538.62974 55.609 1.8289 21.071 1.1992 33.055 2.2045 33.055 2.2045l7.3876-33.005s-75.7-6.8309-113.75-6.8309-113.75 6.8309-113.75 6.8309z",
    fill: "#fed100",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496.5 341.73c38.012-.0193 76.02 2.041 113.86 6.2343l-6.9279 33.312c-37.64-3.3788-68.451-4.2827-106.51-4.5808m.5045-34.966c-38.012-.0193-76.02 2.041-113.86 6.2343l6.9279 33.312c37.64-3.3788 68.451-4.2827 106.51-4.5808",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.1765
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0111 0 0 .77383 772.99 -265.67)",
    strokeWidth: 1.33
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-644.32 561.77-.0312.0312h-.0312c-13.369 1.2568-28.842 2.6278-42.344 5.0312-1.9091 2.9817-2.0675 5.7008 1.4062 7.875 12.963-2.3075 28.246-3.7112 41.625-4.9688 18.145-1.3742 36.44-2.2332 54.688-2.4688h35c10.916 0 33.968.8703 54.688 2.5 20.625 1.6223 41.688 4.9375 41.688 4.9375 3.5944-2.398 3.2039-5.0807 1.25-7.875 0 0-21.258-3.4064-42.312-5.0625-20.96-1.6487-43.984-2.5-55.312-2.5h-35c-18.464.0721-36.901 1.21-55.313 2.5001z",
    color: "#000000",
    fill: "#fed100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-644.32 561.77-.0312.0312h-.0312c-13.369 1.2568-28.842 2.6278-42.344 5.0312-1.9091 2.9817-2.0675 5.7008 1.4062 7.875 12.963-2.3075 28.246-3.7112 41.625-4.9688 18.145-1.3742 36.44-2.2332 54.688-2.4688h35c10.916 0 33.968.8703 54.688 2.5 20.625 1.6223 41.688 4.9375 41.688 4.9375 3.5944-2.398 3.2039-5.0807 1.25-7.875 0 0-21.258-3.4064-42.312-5.0625-20.96-1.6487-43.984-2.5-55.312-2.5h-35c-18.464.0721-36.901 1.21-55.313 2.5001z",
    color: "#000000",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.33
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.94011 0 0 .77383 732.44 -231.28)",
    strokeWidth: 1.3793
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-644.32 561.77-.0312.0312h-.0312c-13.369 1.2568-28.842 2.6278-42.344 5.0312-1.9091 2.9817-2.0675 5.7008 1.4062 7.875 12.963-2.3075 28.246-3.7112 41.625-4.9688 18.145-1.3742 36.44-2.2332 54.688-2.4688h35c10.916 0 33.968.8703 54.688 2.5 20.625 1.6223 41.688 4.9375 41.688 4.9375 3.5944-2.398 3.2039-5.0807 1.25-7.875 0 0-21.258-3.4064-42.312-5.0625-20.96-1.6487-43.984-2.5-55.312-2.5h-35c-18.464.0721-36.901 1.21-55.313 2.5001z",
    color: "#000000",
    fill: "#fed100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-644.32 561.77-.0312.0312h-.0312c-13.369 1.2568-28.842 2.6278-42.344 5.0312-1.9091 2.9817-2.0675 5.7008 1.4062 7.875 12.963-2.3075 28.246-3.7112 41.625-4.9688 18.145-1.3742 36.44-1.7781 54.688-2.0138h35c10.916 0 33.968.41526 54.688 2.045 20.625 1.6223 41.688 4.9375 41.688 4.9375 3.5944-2.398 3.2039-5.0807 1.25-7.875 0 0-21.258-3.4064-42.312-5.0625-20.96-1.6487-43.984-2.045-55.312-2.045h-35c-18.464.0721-36.901.75492-55.313 2.0451z",
    color: "#000000",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.3793
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.20976 .6899)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-302.32 -173.09)",
    strokeWidth: 2.6601
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.50554 0 0 .38692 -961.11 29.491)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2840.1,
    y: 823.57,
    width: 89.493,
    height: 59.169,
    ry: 3.0061,
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.6601
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.50554 0 0 .38692 -961.11 29.491)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.6601
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2849.7,
    y: 831.33,
    width: 70.263,
    height: 43.637,
    ry: 5.1773,
    fill: "#012169",
    fillRule: "evenodd",
    stroke: "#a0892c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2918.5 873.46c-.9358.93579-2.2301 1.5131-3.6642 1.5131h-59.908c-1.4341 0-2.7284-.57727-3.6642-1.5131-.9357-.93579-1.513-2.2301-1.513-3.6642v-33.282c0-1.4341.5773-2.7284 1.513-3.6642.9358-.93579 68.172 39.675 67.237 40.611z",
    fill: "#2b96f6",
    fillRule: "evenodd",
    stroke: "#a0892c"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#012169",
    fillRule: "evenodd",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2918.5 873.46c-.9358.93581-2.2301 1.5131-3.6642 1.5131h-59.908c-1.4341 0-2.7284-.57727-3.6642-1.5131-.9357-.93579-1.513-2.2301-1.513-3.6642v-33.282c0-1.4341.5773-2.7284 1.513-3.6642.4751-.47512 18.04 9.7588 35.096 20.073 16.539 10.001 32.601 20.077 32.14 20.538z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2918.5 832.84c.9357.93579 1.513 2.2301 1.513 3.6642v33.282c0 1.4341-.5773 2.7284-1.513 3.6642-.9358.93579-2.2301 1.5131-3.6642 1.5131h-59.908c-1.4341 0-2.7284-.57727-3.6642-1.5131-.9357-.93579 66.301-41.547 67.237-40.611z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2918.5 873.46c-.9358.93579-2.2301 1.5131-3.6642 1.5131h-59.908c-1.4341 0-2.7284-.57725-3.6642-1.5131-.4748-.47478 16.6-11.163 33.661-21.457 0 0 34.512 20.521 33.576 21.457z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2849.7,
    y: 831.33,
    width: 70.263,
    height: 43.637,
    ry: 5.1773,
    fill: "none",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2865.2,
    y: 841.29,
    width: 39.367,
    height: 22.304,
    ry: 0,
    fill: "#012169",
    fillRule: "evenodd",
    stroke: "#000"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-302.24 -173.09)",
    strokeWidth: 1.1765
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.87076 -.01395 .01558 .77968 -53.131 133.63)",
    strokeWidth: 1.4276
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.99582 -.091287 .13843 .99037 0 0)",
    x: 494.63,
    y: 340.21,
    width: 35.829,
    height: 22.674,
    ry: 10.771,
    fill: "#fed100",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.4284
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.99582 -.091287 .13843 .99037 0 0)",
    x: 497.57,
    y: 343.28,
    width: 29.954,
    height: 16.542,
    ry: 8.271,
    fill: "#306947",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.99582 -.091287 .13843 .99037 0 0)",
    x: 497.57,
    y: 343.28,
    width: 29.954,
    height: 16.542,
    ry: 8.271,
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.4284
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.81814 .14282 .15467 .88602 852.1 11.28)",
    strokeWidth: 1.3612
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m626.17 310.88-23.701-12.771 23.701-12.082 2.8814 13.147z",
    fill: "#fed100",
    stroke: "#000",
    strokeWidth: 1.3612
  }), /*#__PURE__*/React.createElement("path", {
    d: "m626.17 307.47-17.183-9.2586 17.183-8.759 5.657 8.5789z",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m626.17 307.47-17.183-9.2586 22.66-.18009z",
    fill: "#c8102e"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "translate(156.53 47.58)",
    d: "m452.4 250.56 22.953-.0249",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.3612
  }), /*#__PURE__*/React.createElement("path", {
    d: "m626.17 307.47-17.183-9.2586 17.183-8.759 5.8371 8.3988z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.3612
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.77786 -117.02)",
    strokeWidth: 1.4524
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.9 0 0 .9 292.52 -504.08)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.9 0 0 .9 18.93 108.07)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.45 0 0 .45 -1021.1 731)",
    strokeWidth: 3.2276
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 3.2276
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.9 0 0 .9 19.798 121.61)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.45 0 0 .45 -1021.1 731)",
    strokeWidth: 3.2276
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 3.2258
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.9 0 0 .9 241.08 -501.27)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.9 0 0 .9 18.93 108.07)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.45 0 0 .45 -1021.1 731)",
    strokeWidth: 3.2276
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 3.2276
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.9 0 0 .9 19.798 121.61)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.45 0 0 .45 -1021.1 731)",
    strokeWidth: 3.2276
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 3.2276
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 994.39 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.87076 -.01395 .01558 .77968 -53.131 133.63)",
    strokeWidth: 1.4276
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.99582 -.091287 .13843 .99037 0 0)",
    x: 494.63,
    y: 340.21,
    width: 35.829,
    height: 22.674,
    ry: 10.771,
    fill: "#fed100",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.4284
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.99582 -.091287 .13843 .99037 0 0)",
    x: 497.57,
    y: 343.28,
    width: 29.954,
    height: 16.542,
    ry: 8.271,
    fill: "#306947",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.99582 -.091287 .13843 .99037 0 0)",
    x: 497.57,
    y: 343.28,
    width: 29.954,
    height: 16.542,
    ry: 8.271,
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.4284
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.81814 .14282 .15467 .88602 852.1 11.28)",
    strokeWidth: 1.3612
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m626.17 310.88-23.701-12.771 23.701-12.082 2.8814 13.147z",
    fill: "#fed100",
    stroke: "#000",
    strokeWidth: 1.3612
  }), /*#__PURE__*/React.createElement("path", {
    d: "m626.17 307.47-17.183-9.2586 17.183-8.759 5.657 8.5789z",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m626.17 307.47-17.183-9.2586 22.66-.18009z",
    fill: "#c8102e"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "translate(156.53 47.58)",
    d: "m452.4 250.56 22.953-.0249",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.3612
  }), /*#__PURE__*/React.createElement("path", {
    d: "m626.17 307.47-17.183-9.2586 17.183-8.759 5.8371 8.3988z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.3612
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.77786 -117.02)",
    strokeWidth: 1.4524
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.9 0 0 .9 292.52 -504.08)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.9 0 0 .9 18.93 108.07)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.45 0 0 .45 -1021.1 731)",
    strokeWidth: 3.2276
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 3.2276
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.9 0 0 .9 19.798 121.61)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.45 0 0 .45 -1021.1 731)",
    strokeWidth: 3.2276
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 3.2276
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.9 0 0 .9 241.08 -501.27)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.9 0 0 .9 18.93 108.07)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.45 0 0 .45 -1021.1 731)",
    strokeWidth: 3.2276
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 3.2276
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.9 0 0 .9 19.798 121.61)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.45 0 0 .45 -1021.1 731)",
    strokeWidth: 3.2276
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.0633)",
    d: "m2700.2 785.03a10.489 10.66 0 11-20.977 0 10.489 10.66 0 1120.977 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 3.2276
  }))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIo);
export default __webpack_public_path__ + "static/media/io.e3e96cdc532c8946cad0a5583733bea3.svg";
export { ForwardRef as ReactComponent };